// extracted by mini-css-extract-plugin
export default {"p_content":"_4f6214d47a"};